import React, { Component } from 'react'

class NavLogo extends Component {
render() {
    return (  
        <svg height="42" viewBox="0 0 355 79" alt="logo">
<style type="text/css">
	{`.st0{fill:#FFFFFF}`}
</style>
<g>
	<g>
		<path className="st0" d="M58.31,21.47c0.5,0.37,1.2,0.26,1.57-0.23c0.38-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.21-0.27-1.58,0.23
			C57.71,20.4,57.81,21.1,58.31,21.47z"/>
		<path className="st0" d="M58.98,20.57"/>
	</g>
	<g>
		<path className="st0" d="M53.73,21.5c0.5,0.37,1.2,0.27,1.58-0.23c0.37-0.5,0.27-1.21-0.23-1.58c-0.5-0.37-1.2-0.27-1.57,0.23
			C53.13,20.42,53.24,21.13,53.73,21.5z"/>
		<path className="st0" d="M54.41,20.6"/>
	</g>
	<g>
		<path className="st0" d="M50.66,22.27c0.5,0.37,1.2,0.26,1.57-0.23c0.37-0.5,0.28-1.2-0.22-1.58c-0.5-0.37-1.21-0.27-1.58,0.23
			C50.07,21.19,50.17,21.9,50.66,22.27z"/>
		<path className="st0" d="M51.34,21.37"/>
	</g>
	<g>
		<path className="st0" d="M47.39,23.41c0.49,0.37,1.2,0.27,1.57-0.23c0.37-0.5,0.27-1.2-0.23-1.57c-0.49-0.37-1.2-0.27-1.57,0.23
			C46.79,22.33,46.89,23.03,47.39,23.41z"/>
		<path className="st0" d="M48.06,22.5"/>
	</g>
	<g>
		<path className="st0" d="M44.89,25.39c0.5,0.37,1.2,0.27,1.57-0.23c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.21-0.27-1.57,0.23
			C44.29,24.31,44.39,25.02,44.89,25.39z"/>
		<path className="st0" d="M45.56,24.49"/>
	</g>
	<g>
		<path className="st0" d="M42.8,27.52c0.5,0.38,1.2,0.27,1.57-0.23c0.37-0.5,0.26-1.2-0.23-1.58c-0.5-0.37-1.2-0.27-1.58,0.23
			C42.19,26.45,42.3,27.15,42.8,27.52z"/>
		<path className="st0" d="M43.47,26.62"/>
	</g>
	<g>
		<path className="st0" d="M40.98,29.73c0.5,0.37,1.2,0.27,1.57-0.23c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.21-0.27-1.57,0.23
			C40.38,28.66,40.48,29.36,40.98,29.73z"/>
		<path className="st0" d="M41.65,28.84"/>
	</g>
	<g>
		<path className="st0" d="M39.73,31.87c0.5,0.37,1.2,0.27,1.57-0.23c0.37-0.5,0.26-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23
			C39.13,30.79,39.23,31.49,39.73,31.87z"/>
		<path className="st0" d="M40.4,30.96"/>
	</g>
	<g>
		<path className="st0" d="M38.95,34.06c0.5,0.37,1.2,0.27,1.57-0.23c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.58,0.23
			C38.34,32.98,38.45,33.69,38.95,34.06z"/>
		<path className="st0" d="M39.62,33.16"/>
	</g>
	<g>
		<path className="st0" d="M64,18.68c0.56,0.27,1.23,0.03,1.49-0.53c0.26-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.02-1.5,0.53
			C63.2,17.74,63.44,18.41,64,18.68z"/>
		<path className="st0" d="M64.48,17.67"/>
	</g>
	<g>
		<path className="st0" d="M56.16,17.41c0.56,0.26,1.24,0.03,1.5-0.54c0.27-0.56,0.03-1.23-0.53-1.5c-0.57-0.26-1.23-0.03-1.5,0.54
			C55.37,16.47,55.6,17.15,56.16,17.41z"/>
		<path className="st0" d="M56.64,16.4"/>
	</g>
	<g>
		<path className="st0" d="M52.42,18.2c0.56,0.26,1.23,0.03,1.5-0.53c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53
			C51.62,17.26,51.86,17.93,52.42,18.2z"/>
		<path className="st0" d="M52.9,17.19"/>
	</g>
	<g>
		<path className="st0" d="M49.06,19.67c0.56,0.27,1.23,0.03,1.5-0.53c0.27-0.56,0.03-1.23-0.54-1.5c-0.56-0.26-1.23-0.02-1.5,0.53
			C48.25,18.73,48.49,19.4,49.06,19.67z"/>
		<path className="st0" d="M49.53,18.65"/>
	</g>
	<g>
		<path className="st0" d="M46.19,21.03c0.56,0.27,1.23,0.03,1.5-0.53c0.27-0.56,0.03-1.24-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53
			C45.4,20.09,45.64,20.76,46.19,21.03z"/>
		<path className="st0" d="M46.68,20.01"/>
	</g>
	<g>
		<path className="st0" d="M43.2,22.77c0.56,0.27,1.24,0.03,1.5-0.53c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.24-0.03-1.5,0.53
			C42.4,21.84,42.64,22.51,43.2,22.77z"/>
		<path className="st0" d="M43.68,21.76"/>
	</g>
	<g>
		<path className="st0" d="M41.14,25.21c0.56,0.27,1.23,0.03,1.5-0.53c0.26-0.56,0.02-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53
			C40.34,24.28,40.58,24.95,41.14,25.21z"/>
		<path className="st0" d="M41.62,24.2"/>
	</g>
	<g>
		<path className="st0" d="M39.5,27.71c0.55,0.27,1.23,0.03,1.5-0.53c0.26-0.56,0.02-1.23-0.54-1.5c-0.56-0.26-1.23-0.03-1.5,0.54
			C38.7,26.77,38.94,27.44,39.5,27.71z"/>
		<path className="st0" d="M39.98,26.69"/>
	</g>
	<g>
		<path className="st0" d="M38.15,30.23c0.56,0.26,1.23,0.03,1.5-0.53c0.26-0.56,0.03-1.23-0.54-1.49c-0.56-0.27-1.23-0.03-1.5,0.53
			C37.35,29.3,37.59,29.97,38.15,30.23z"/>
		<path className="st0" d="M38.63,29.22"/>
	</g>
	<g>
		<path className="st0" d="M37.34,32.57c0.56,0.27,1.24,0.03,1.5-0.53c0.26-0.56,0.03-1.23-0.54-1.5c-0.55-0.27-1.23-0.03-1.5,0.53
			C36.54,31.63,36.78,32.3,37.34,32.57z"/>
		<path className="st0" d="M37.82,31.55"/>
	</g>
	<g>
		<path className="st0" d="M37,34.87c0.56,0.27,1.24,0.03,1.5-0.53c0.27-0.56,0.03-1.23-0.54-1.5c-0.56-0.27-1.23-0.03-1.49,0.54
			C36.21,33.94,36.44,34.6,37,34.87z"/>
		<path className="st0" d="M37.48,33.85"/>
	</g>
	<g>
		<path className="st0" d="M58.82,13.22c0.6,0.15,1.21-0.22,1.37-0.82c0.15-0.6-0.22-1.22-0.82-1.36c-0.6-0.15-1.21,0.21-1.36,0.81
			C57.85,12.46,58.22,13.07,58.82,13.22z"/>
		<path className="st0" d="M59.09,12.13"/>
	</g>
	<g>
		<path className="st0" d="M54.6,13.98c0.6,0.16,1.21-0.21,1.37-0.81c0.15-0.6-0.22-1.22-0.82-1.37c-0.6-0.15-1.21,0.22-1.37,0.82
			C53.63,13.22,54,13.84,54.6,13.98z"/>
		<path className="st0" d="M54.87,12.9"/>
	</g>
	<g>
		<path className="st0" d="M50.64,15.19c0.6,0.15,1.21-0.21,1.36-0.82c0.16-0.6-0.22-1.21-0.82-1.36c-0.6-0.15-1.21,0.22-1.36,0.81
			C49.67,14.42,50.03,15.04,50.64,15.19z"/>
		<path className="st0" d="M50.91,14.1"/>
	</g>
	<g>
		<path className="st0" d="M47.12,16.69c0.6,0.15,1.21-0.22,1.36-0.82c0.15-0.6-0.21-1.21-0.82-1.36c-0.6-0.15-1.21,0.21-1.36,0.81
			C46.16,15.92,46.52,16.53,47.12,16.69z"/>
		<path className="st0" d="M47.4,15.6"/>
	</g>
	<g>
		<path className="st0" d="M44.11,18.79c0.6,0.16,1.21-0.21,1.36-0.81c0.15-0.6-0.21-1.21-0.81-1.36c-0.6-0.15-1.22,0.21-1.37,0.81
			C43.14,18.02,43.5,18.63,44.11,18.79z"/>
		<path className="st0" d="M44.38,17.7"/>
	</g>
	<g>
		<path className="st0" d="M41.56,20.68c0.61,0.15,1.22-0.22,1.37-0.82c0.15-0.6-0.22-1.22-0.82-1.37c-0.6-0.15-1.22,0.22-1.37,0.82
			C40.6,19.91,40.97,20.52,41.56,20.68z"/>
		<path className="st0" d="M41.84,19.59"/>
	</g>
	<g>
		<path className="st0" d="M38.97,22.98c0.6,0.15,1.21-0.21,1.37-0.82c0.15-0.6-0.21-1.21-0.82-1.37c-0.6-0.15-1.21,0.22-1.37,0.82
			C38,22.22,38.37,22.82,38.97,22.98z"/>
		<path className="st0" d="M39.24,21.89"/>
	</g>
	<g>
		<path className="st0" d="M37.43,25.77c0.6,0.15,1.21-0.22,1.36-0.81c0.15-0.61-0.21-1.22-0.82-1.37c-0.6-0.15-1.22,0.22-1.36,0.82
			C36.46,25,36.82,25.62,37.43,25.77z"/>
		<path className="st0" d="M37.69,24.68"/>
	</g>
	<g>
		<path className="st0" d="M36.3,28.53c0.6,0.15,1.22-0.21,1.36-0.81c0.16-0.6-0.21-1.22-0.81-1.37c-0.6-0.15-1.22,0.21-1.36,0.82
			C35.33,27.77,35.7,28.39,36.3,28.53z"/>
		<path className="st0" d="M36.58,27.45"/>
	</g>
	<g>
		<path className="st0" d="M35.47,31.27c0.6,0.16,1.21-0.21,1.36-0.81c0.16-0.6-0.21-1.22-0.81-1.37c-0.6-0.15-1.21,0.22-1.37,0.82
			C34.5,30.51,34.87,31.13,35.47,31.27z"/>
		<path className="st0" d="M35.75,30.19"/>
	</g>
	<g>
		<path className="st0" d="M35.14,33.73c0.6,0.15,1.21-0.22,1.36-0.82c0.15-0.6-0.21-1.21-0.82-1.36c-0.6-0.15-1.22,0.21-1.37,0.81
			C34.17,32.96,34.53,33.57,35.14,33.73z"/>
		<path className="st0" d="M35.41,32.63"/>
	</g>
	<g>
		<path className="st0" d="M35.25,36.05c0.6,0.16,1.22-0.21,1.37-0.82c0.15-0.6-0.21-1.21-0.82-1.37c-0.6-0.15-1.22,0.22-1.36,0.82
			C34.28,35.28,34.64,35.89,35.25,36.05z"/>
		<path className="st0" d="M35.52,34.96"/>
	</g>
	<g>
		<path className="st0" d="M52.42,10.56c0.62,0.03,1.15-0.45,1.18-1.07c0.03-0.62-0.45-1.15-1.06-1.18c-0.62-0.03-1.15,0.45-1.18,1.07
			C51.33,10,51.8,10.53,52.42,10.56z"/>
		<path className="st0" d="M52.49,9.44"/>
	</g>
	<g>
		<path className="st0" d="M48.43,12.13c0.62,0.03,1.15-0.44,1.18-1.07c0.03-0.62-0.44-1.15-1.06-1.18c-0.62-0.04-1.15,0.44-1.18,1.06
			C47.33,11.57,47.81,12.1,48.43,12.13z"/>
		<path className="st0" d="M48.49,11.01"/>
	</g>
	<g>
		<path className="st0" d="M44.79,14.08c0.62,0.03,1.15-0.44,1.18-1.06c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.07
			C43.69,13.52,44.16,14.05,44.79,14.08z"/>
		<path className="st0" d="M44.84,12.96"/>
	</g>
	<g>
		<path className="st0" d="M41.63,16.24c0.62,0.03,1.15-0.45,1.18-1.06c0.03-0.62-0.44-1.15-1.07-1.18c-0.62-0.03-1.15,0.44-1.18,1.07
			C40.53,15.68,41,16.21,41.63,16.24z"/>
		<path className="st0" d="M41.68,15.12"/>
	</g>
	<g>
		<path className="st0" d="M39.08,18.89c0.62,0.03,1.15-0.45,1.18-1.06c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.06
			C37.98,18.33,38.46,18.86,39.08,18.89z"/>
		<path className="st0" d="M39.14,17.77"/>
	</g>
	<g>
		<path className="st0" d="M36.96,21.24c0.62,0.03,1.15-0.45,1.18-1.07c0.03-0.62-0.45-1.15-1.06-1.18c-0.62-0.03-1.15,0.45-1.19,1.07
			C35.86,20.68,36.34,21.21,36.96,21.24z"/>
		<path className="st0" d="M37.02,20.11"/>
	</g>
	<g>
		<path className="st0" d="M34.87,24c0.62,0.03,1.14-0.44,1.18-1.06c0.03-0.63-0.45-1.15-1.07-1.19c-0.62-0.03-1.15,0.45-1.18,1.07
			C33.76,23.44,34.24,23.97,34.87,24z"/>
		<path className="st0" d="M34.92,22.88"/>
	</g>
	<g>
		<path className="st0" d="M33.89,27.04c0.62,0.03,1.15-0.44,1.18-1.07c0.03-0.62-0.45-1.15-1.06-1.18c-0.62-0.03-1.15,0.44-1.18,1.07
			C32.79,26.48,33.27,27.01,33.89,27.04z"/>
		<path className="st0" d="M33.95,25.92"/>
	</g>
	<g>
		<path className="st0" d="M33.33,29.97c0.62,0.03,1.15-0.44,1.18-1.07c0.03-0.62-0.45-1.15-1.07-1.17c-0.62-0.03-1.15,0.44-1.18,1.06
			C32.23,29.41,32.71,29.94,33.33,29.97z"/>
		<path className="st0" d="M33.39,28.85"/>
	</g>
	<g>
		<path className="st0" d="M33.05,32.83c0.62,0.03,1.15-0.45,1.18-1.07c0.03-0.62-0.44-1.15-1.06-1.18c-0.62-0.04-1.15,0.44-1.18,1.07
			C31.95,32.26,32.43,32.79,33.05,32.83z"/>
		<path className="st0" d="M33.1,31.7"/>
	</g>
	<g>
		<path className="st0" d="M33.2,35.29c0.62,0.03,1.14-0.45,1.18-1.07c0.04-0.62-0.45-1.14-1.06-1.18c-0.62-0.04-1.15,0.44-1.18,1.06
			C32.1,34.73,32.57,35.25,33.2,35.29z"/>
		<path className="st0" d="M33.25,34.17"/>
	</g>
	<g>
		<path className="st0" d="M33.76,37.54c0.62,0.04,1.15-0.44,1.18-1.06c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.44-1.18,1.07
			C32.66,36.99,33.14,37.51,33.76,37.54z"/>
		<path className="st0" d="M33.82,36.42"/>
	</g>
	<g>
		<path className="st0" d="M45.64,9.2c0.61-0.09,1.04-0.67,0.95-1.28c-0.09-0.61-0.66-1.04-1.28-0.95c-0.62,0.09-1.04,0.66-0.95,1.27
			C44.45,8.86,45.02,9.29,45.64,9.2z"/>
		<path className="st0" d="M45.47,8.08"/>
	</g>
	<g>
		<path className="st0" d="M42.03,11.52c0.61-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.66-1.04-1.28-0.95c-0.61,0.09-1.03,0.66-0.94,1.28
			C40.84,11.18,41.41,11.6,42.03,11.52z"/>
		<path className="st0" d="M41.86,10.4"/>
	</g>
	<g>
		<path className="st0" d="M38.83,14.14c0.61-0.09,1.04-0.66,0.95-1.28c-0.1-0.61-0.67-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.27
			C37.64,13.81,38.21,14.23,38.83,14.14z"/>
		<path className="st0" d="M38.67,13.03"/>
	</g>
	<g>
		<path className="st0" d="M36.15,16.88c0.61-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.27
			C34.96,16.54,35.53,16.97,36.15,16.88z"/>
		<path className="st0" d="M35.99,15.76"/>
	</g>
	<g>
		<path className="st0" d="M34.17,19.97c0.61-0.09,1.04-0.66,0.95-1.28c-0.09-0.62-0.66-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.94,1.27
			C32.98,19.63,33.55,20.06,34.17,19.97z"/>
		<path className="st0" d="M34.01,18.86"/>
	</g>
	<g>
		<path className="st0" d="M32.55,22.69c0.61-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.66-1.03-1.27-0.95c-0.62,0.09-1.04,0.67-0.95,1.28
			C31.36,22.35,31.93,22.77,32.55,22.69z"/>
		<path className="st0" d="M32.38,21.57"/>
	</g>
	<g>
		<path className="st0" d="M31.03,25.8c0.61-0.09,1.03-0.66,0.95-1.27c-0.09-0.61-0.66-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28
			C29.85,25.47,30.42,25.89,31.03,25.8z"/>
		<path className="st0" d="M30.87,24.69"/>
	</g>
	<g>
		<path className="st0" d="M30.67,28.98c0.62-0.09,1.04-0.66,0.95-1.27c-0.09-0.62-0.66-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28
			C29.48,28.64,30.05,29.07,30.67,28.98z"/>
		<path className="st0" d="M30.51,27.86"/>
	</g>
	<g>
		<path className="st0" d="M30.69,31.96c0.62-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.67-1.04-1.28-0.95c-0.62,0.09-1.04,0.65-0.95,1.27
			C29.51,31.62,30.08,32.05,30.69,31.96z"/>
		<path className="st0" d="M30.53,30.85"/>
	</g>
	<g>
		<path className="st0" d="M30.97,34.81c0.62-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.66-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28
			C29.79,34.48,30.36,34.9,30.97,34.81z"/>
		<path className="st0" d="M30.81,33.7"/>
	</g>
	<g>
		<path className="st0" d="M31.6,37.2c0.62-0.09,1.04-0.66,0.95-1.28c-0.09-0.61-0.66-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28
			C30.41,36.86,30.98,37.29,31.6,37.2z"/>
		<path className="st0" d="M31.43,36.09"/>
	</g>
	<g>
		<path className="st0" d="M32.6,39.31c0.61-0.09,1.03-0.66,0.95-1.27c-0.09-0.62-0.66-1.04-1.28-0.95c-0.62,0.09-1.04,0.66-0.95,1.27
			C31.41,38.97,31.98,39.4,32.6,39.31z"/>
		<path className="st0" d="M32.43,38.2"/>
	</g>
	<g>
		<path className="st0" d="M38.71,9.18c0.59-0.21,0.89-0.85,0.68-1.43c-0.21-0.59-0.85-0.89-1.43-0.68c-0.59,0.21-0.89,0.85-0.69,1.44
			C37.48,9.08,38.12,9.39,38.71,9.18z"/>
		<path className="st0" d="M38.33,8.12"/>
	</g>
	<g>
		<path className="st0" d="M35.62,12.16c0.58-0.21,0.89-0.85,0.68-1.44c-0.2-0.58-0.85-0.89-1.43-0.68c-0.59,0.21-0.89,0.85-0.68,1.44
			C34.39,12.06,35.03,12.37,35.62,12.16z"/>
		<path className="st0" d="M35.24,11.1"/>
	</g>
	<g>
		<path className="st0" d="M33,15.36c0.59-0.2,0.89-0.85,0.68-1.44c-0.2-0.59-0.85-0.89-1.44-0.68c-0.58,0.2-0.89,0.85-0.68,1.43
			C31.77,15.26,32.41,15.57,33,15.36z"/>
		<path className="st0" d="M32.62,14.3"/>
	</g>
	<g>
		<path className="st0" d="M30.91,18.56c0.58-0.21,0.89-0.85,0.68-1.43c-0.21-0.59-0.85-0.89-1.44-0.69c-0.58,0.21-0.89,0.85-0.68,1.44
			C29.67,18.47,30.32,18.77,30.91,18.56z"/>
		<path className="st0" d="M30.53,17.51"/>
	</g>
	<g>
		<path className="st0" d="M29.57,21.99c0.58-0.21,0.89-0.85,0.68-1.44c-0.21-0.59-0.85-0.89-1.44-0.68c-0.58,0.21-0.89,0.85-0.68,1.44
			C28.34,21.89,28.98,22.2,29.57,21.99z"/>
		<path className="st0" d="M29.19,20.93"/>
	</g>
	<g>
		<path className="st0" d="M28.51,24.97c0.58-0.21,0.89-0.85,0.68-1.44c-0.21-0.58-0.85-0.9-1.44-0.68c-0.58,0.21-0.89,0.85-0.68,1.43
			C27.28,24.87,27.92,25.17,28.51,24.97z"/>
		<path className="st0" d="M28.13,23.9"/>
	</g>
	<g>
		<path className="st0" d="M27.63,28.32c0.58-0.21,0.88-0.85,0.68-1.44c-0.21-0.58-0.85-0.89-1.43-0.68c-0.58,0.21-0.89,0.85-0.68,1.44
			C26.39,28.22,27.04,28.53,27.63,28.32z"/>
		<path className="st0" d="M27.25,27.26"/>
	</g>
	<g>
		<path className="st0" d="M27.88,31.5c0.59-0.21,0.89-0.85,0.69-1.44c-0.21-0.58-0.85-0.88-1.44-0.68c-0.58,0.2-0.89,0.85-0.68,1.43
			C26.66,31.41,27.3,31.71,27.88,31.5z"/>
		<path className="st0" d="M27.51,30.44"/>
	</g>
	<g>
		<path className="st0" d="M28.49,34.42c0.59-0.21,0.89-0.85,0.68-1.44c-0.21-0.58-0.85-0.89-1.43-0.68c-0.58,0.21-0.89,0.85-0.69,1.44
			C27.27,34.33,27.91,34.64,28.49,34.42z"/>
		<path className="st0" d="M28.12,33.36"/>
	</g>
	<g>
		<path className="st0" d="M29.33,37.17c0.58-0.21,0.89-0.85,0.68-1.43c-0.21-0.59-0.85-0.89-1.44-0.69c-0.58,0.21-0.89,0.85-0.69,1.44
			C28.1,37.07,28.74,37.38,29.33,37.17z"/>
		<path className="st0" d="M28.94,36.1"/>
	</g>
	<g>
		<path className="st0" d="M30.4,39.39c0.59-0.21,0.89-0.85,0.68-1.44c-0.21-0.58-0.85-0.89-1.44-0.68c-0.59,0.21-0.89,0.85-0.68,1.43
			C29.17,39.29,29.82,39.6,30.4,39.39z"/>
		<path className="st0" d="M30.03,38.33"/>
	</g>
	<g>
		<path className="st0" d="M31.79,41.26c0.58-0.21,0.89-0.85,0.68-1.44c-0.21-0.58-0.85-0.89-1.43-0.68c-0.59,0.21-0.9,0.85-0.68,1.44
			C30.56,41.16,31.21,41.47,31.79,41.26z"/>
		<path className="st0" d="M31.42,40.2"/>
	</g>
	<g>
		<path className="st0" d="M31.91,10.52c0.53-0.32,0.7-1.01,0.38-1.54c-0.31-0.53-1.01-0.7-1.54-0.39c-0.53,0.32-0.71,1.01-0.39,1.54
			C30.69,10.66,31.38,10.84,31.91,10.52z"/>
		<path className="st0" d="M31.33,9.56"/>
	</g>
	<g>
		<path className="st0" d="M29.46,14.05c0.53-0.32,0.71-1.01,0.39-1.55c-0.32-0.53-1.01-0.71-1.55-0.39c-0.53,0.32-0.7,1.01-0.38,1.54
			C28.24,14.19,28.93,14.36,29.46,14.05z"/>
		<path className="st0" d="M28.89,13.08"/>
	</g>
	<g>
		<path className="st0" d="M27.52,17.69c0.53-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.7-1.54-0.39c-0.54,0.32-0.71,1.01-0.39,1.54
			C26.29,17.84,26.99,18.01,27.52,17.69z"/>
		<path className="st0" d="M26.94,16.73"/>
	</g>
	<g>
		<path className="st0" d="M26.09,21.25c0.53-0.32,0.71-1.02,0.39-1.55c-0.32-0.53-1.01-0.71-1.55-0.39c-0.54,0.32-0.71,1.01-0.39,1.54
			C24.87,21.39,25.56,21.57,26.09,21.25z"/>
		<path className="st0" d="M25.52,20.28"/>
	</g>
	<g>
		<path className="st0" d="M25.44,24.86c0.53-0.32,0.71-1.01,0.39-1.54c-0.31-0.53-1.01-0.71-1.54-0.38c-0.53,0.32-0.71,1.01-0.39,1.54
			C24.22,25,24.91,25.18,25.44,24.86z"/>
		<path className="st0" d="M24.87,23.9"/>
	</g>
	<g>
		<path className="st0" d="M24.98,27.99c0.54-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39c-0.54,0.32-0.71,1.01-0.39,1.54
			C23.76,28.14,24.45,28.31,24.98,27.99z"/>
		<path className="st0" d="M24.41,27.03"/>
	</g>
	<g>
		<path className="st0" d="M24.77,31.45c0.54-0.31,0.71-1.01,0.39-1.54c-0.32-0.54-1.01-0.71-1.54-0.39c-0.53,0.32-0.71,1.01-0.39,1.55
			C23.55,31.6,24.24,31.77,24.77,31.45z"/>
		<path className="st0" d="M24.2,30.49"/>
	</g>
	<g>
		<path className="st0" d="M25.66,34.52c0.53-0.32,0.7-1.01,0.39-1.54c-0.32-0.54-1.01-0.71-1.55-0.39c-0.53,0.32-0.71,1.01-0.39,1.54
			C24.43,34.67,25.12,34.84,25.66,34.52z"/>
		<path className="st0" d="M25.08,33.56"/>
	</g>
	<g>
		<path className="st0" d="M26.82,37.27c0.53-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1-0.71-1.54-0.39c-0.53,0.31-0.71,1-0.39,1.53
			C25.59,37.41,26.29,37.59,26.82,37.27z"/>
		<path className="st0" d="M26.24,36.3"/>
	</g>
	<g>
		<path className="st0" d="M28.17,39.8c0.54-0.32,0.7-1.01,0.39-1.54c-0.32-0.54-1.01-0.71-1.54-0.39c-0.53,0.32-0.71,1-0.39,1.54
			C26.94,39.94,27.63,40.12,28.17,39.8z"/>
		<path className="st0" d="M27.59,38.83"/>
	</g>
	<g>
		<path className="st0" d="M29.66,41.77c0.54-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39c-0.53,0.32-0.71,1.01-0.39,1.54
			C28.44,41.91,29.13,42.08,29.66,41.77z"/>
		<path className="st0" d="M29.08,40.8"/>
	</g>
	<g>
		<path className="st0" d="M31.39,43.33c0.53-0.32,0.7-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.38c-0.53,0.31-0.71,1.01-0.39,1.54
			C30.16,43.48,30.85,43.65,31.39,43.33z"/>
		<path className="st0" d="M30.81,42.36"/>
	</g>
	<g>
		<path className="st0" d="M25.51,13.16c0.46-0.42,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.49-1.59-0.08c-0.46,0.42-0.49,1.13-0.08,1.59
			C24.33,13.54,25.05,13.58,25.51,13.16z"/>
		<path className="st0" d="M24.76,12.32"/>
	</g>
	<g>
		<path className="st0" d="M23.8,17.1c0.46-0.42,0.5-1.13,0.08-1.59c-0.41-0.46-1.13-0.49-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59
			C22.63,17.47,23.34,17.51,23.8,17.1z"/>
		<path className="st0" d="M23.04,16.26"/>
	</g>
	<g>
		<path className="st0" d="M22.6,21.05c0.46-0.41,0.5-1.13,0.08-1.59c-0.42-0.46-1.12-0.5-1.59-0.09c-0.46,0.42-0.5,1.13-0.08,1.59
			C21.43,21.43,22.14,21.47,22.6,21.05z"/>
		<path className="st0" d="M21.84,20.22"/>
	</g>
	<g>
		<path className="st0" d="M21.89,24.82c0.46-0.42,0.5-1.13,0.08-1.59c-0.41-0.46-1.13-0.5-1.59-0.08c-0.46,0.41-0.5,1.13-0.08,1.59
			C20.72,25.2,21.43,25.23,21.89,24.82z"/>
		<path className="st0" d="M21.14,23.98"/>
	</g>
	<g>
		<path className="st0" d="M21.96,28.49c0.46-0.42,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59
			C20.79,28.87,21.5,28.9,21.96,28.49z"/>
		<path className="st0" d="M21.21,27.65"/>
	</g>
	<g>
		<path className="st0" d="M22.12,31.65c0.46-0.42,0.5-1.13,0.09-1.58c-0.42-0.46-1.13-0.5-1.59-0.08c-0.46,0.41-0.5,1.12-0.08,1.58
			C20.95,32.03,21.66,32.07,22.12,31.65z"/>
		<path className="st0" d="M21.37,30.81"/>
	</g>
	<g>
		<path className="st0" d="M22.59,35.08c0.46-0.42,0.5-1.13,0.08-1.59c-0.41-0.46-1.13-0.5-1.59-0.08c-0.46,0.41-0.5,1.13-0.08,1.59
			C21.42,35.46,22.13,35.5,22.59,35.08z"/>
		<path className="st0" d="M21.84,34.25"/>
	</g>
	<g>
		<path className="st0" d="M24.05,37.92c0.47-0.42,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59
			C22.88,38.3,23.6,38.34,24.05,37.92z"/>
		<path className="st0" d="M23.3,37.09"/>
	</g>
	<g>
		<path className="st0" d="M25.73,40.39c0.46-0.42,0.5-1.13,0.08-1.59c-0.41-0.47-1.13-0.5-1.59-0.08c-0.46,0.41-0.49,1.13-0.08,1.59
			C24.56,40.77,25.27,40.8,25.73,40.39z"/>
		<path className="st0" d="M24.97,39.56"/>
	</g>
	<g>
		<path className="st0" d="M27.55,42.61c0.46-0.42,0.5-1.13,0.08-1.59c-0.42-0.47-1.12-0.5-1.58-0.08c-0.46,0.42-0.5,1.13-0.09,1.59
			C26.38,42.99,27.09,43.02,27.55,42.61z"/>
		<path className="st0" d="M26.79,41.77"/>
	</g>
	<g>
		<path className="st0" d="M29.4,44.24c0.46-0.41,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.5-1.59-0.08c-0.46,0.42-0.49,1.13-0.08,1.59
			C28.23,44.63,28.93,44.66,29.4,44.24z"/>
		<path className="st0" d="M28.64,43.41"/>
	</g>
	<g>
		<path className="st0" d="M31.39,45.44c0.46-0.41,0.5-1.13,0.08-1.58c-0.41-0.46-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59
			C30.22,45.82,30.93,45.85,31.39,45.44z"/>
		<path className="st0" d="M30.64,44.61"/>
	</g>
	<g>
		<path className="st0" d="M19.74,17c0.37-0.5,0.26-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.57
			C18.67,17.59,19.37,17.49,19.74,17z"/>
		<path className="st0" d="M18.85,16.33"/>
	</g>
	<g>
		<path className="st0" d="M18.83,21.19c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.58,0.23c-0.37,0.5-0.27,1.2,0.23,1.57
			C17.75,21.79,18.46,21.69,18.83,21.19z"/>
		<path className="st0" d="M17.93,20.52"/>
	</g>
	<g>
		<path className="st0" d="M18.43,25.3c0.37-0.49,0.27-1.2-0.23-1.57c-0.5-0.38-1.2-0.27-1.58,0.23c-0.37,0.5-0.27,1.2,0.23,1.58
			C17.35,25.91,18.06,25.8,18.43,25.3z"/>
		<path className="st0" d="M17.52,24.64"/>
	</g>
	<g>
		<path className="st0" d="M18.47,29.13c0.37-0.5,0.27-1.2-0.23-1.58c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.21,0.23,1.58
			C17.39,29.74,18.1,29.63,18.47,29.13z"/>
		<path className="st0" d="M17.57,28.46"/>
	</g>
	<g>
		<path className="st0" d="M19.25,32.72c0.37-0.49,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.58,0.23c-0.37,0.5-0.27,1.21,0.23,1.58
			C18.18,33.32,18.88,33.22,19.25,32.72z"/>
		<path className="st0" d="M18.35,32.05"/>
	</g>
	<g>
		<path className="st0" d="M20.03,35.79c0.38-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.49-0.27,1.2,0.23,1.57
			C18.95,36.39,19.66,36.29,20.03,35.79z"/>
		<path className="st0" d="M19.13,35.12"/>
	</g>
	<g>
		<path className="st0" d="M21.16,39.07c0.37-0.5,0.26-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.57
			C20.08,39.67,20.79,39.57,21.16,39.07z"/>
		<path className="st0" d="M20.25,38.39"/>
	</g>
	<g>
		<path className="st0" d="M23.15,41.57c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.26-1.58,0.23c-0.37,0.49-0.26,1.2,0.23,1.57
			C22.07,42.17,22.78,42.07,23.15,41.57z"/>
		<path className="st0" d="M22.25,40.9"/>
	</g>
	<g>
		<path className="st0" d="M25.27,43.66c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.38-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.57
			C24.19,44.26,24.9,44.15,25.27,43.66z"/>
		<path className="st0" d="M24.37,42.99"/>
	</g>
	<g>
		<path className="st0" d="M27.48,45.48c0.37-0.5,0.27-1.2-0.23-1.57c-0.49-0.37-1.2-0.27-1.57,0.24c-0.37,0.49-0.27,1.2,0.23,1.57
			C26.41,46.08,27.12,45.98,27.48,45.48z"/>
		<path className="st0" d="M26.59,44.81"/>
	</g>
	<g>
		<path className="st0" d="M29.62,46.72c0.37-0.49,0.26-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.58
			C28.55,47.32,29.25,47.22,29.62,46.72z"/>
		<path className="st0" d="M28.72,46.05"/>
	</g>
	<g>
		<path className="st0" d="M31.81,47.51c0.37-0.5,0.27-1.2-0.23-1.57c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.58
			C30.74,48.11,31.44,48,31.81,47.51z"/>
		<path className="st0" d="M30.91,46.83"/>
	</g>
	<g>
		<path className="st0" d="M14.84,21.89c0.26-0.57,0.03-1.24-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C13.9,22.68,14.57,22.44,14.84,21.89z"/>
		<path className="st0" d="M13.82,21.4"/>
	</g>
	<g>
		<path className="st0" d="M14.76,26.18c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C13.83,26.97,14.49,26.74,14.76,26.18z"/>
		<path className="st0" d="M13.74,25.69"/>
	</g>
	<g>
		<path className="st0" d="M15.17,30.29c0.26-0.56,0.03-1.23-0.53-1.5c-0.57-0.27-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C14.23,31.09,14.9,30.85,15.17,30.29z"/>
		<path className="st0" d="M14.15,29.81"/>
	</g>
	<g>
		<path className="st0" d="M15.95,34.04c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.02-1.5,0.53c-0.27,0.56-0.02,1.23,0.54,1.5
			C15.02,34.84,15.69,34.6,15.95,34.04z"/>
		<path className="st0" d="M14.94,33.55"/>
	</g>
	<g>
		<path className="st0" d="M17.42,37.4c0.27-0.56,0.03-1.23-0.54-1.5c-0.56-0.27-1.23-0.03-1.5,0.54c-0.27,0.56-0.03,1.23,0.53,1.5
			C16.49,38.2,17.16,37.96,17.42,37.4z"/>
		<path className="st0" d="M16.41,36.92"/>
	</g>
	<g>
		<path className="st0" d="M18.78,40.26c0.26-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C17.84,41.06,18.51,40.82,18.78,40.26z"/>
		<path className="st0" d="M17.76,39.78"/>
	</g>
	<g>
		<path className="st0" d="M20.53,43.26c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.54,1.5
			C19.59,44.05,20.26,43.82,20.53,43.26z"/>
		<path className="st0" d="M19.51,42.77"/>
	</g>
	<g>
		<path className="st0" d="M22.97,45.32c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.24-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C22.03,46.12,22.7,45.88,22.97,45.32z"/>
		<path className="st0" d="M21.95,44.83"/>
	</g>
	<g>
		<path className="st0" d="M25.46,46.96c0.27-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.26,0.56-0.03,1.23,0.53,1.5
			C24.52,47.76,25.2,47.51,25.46,46.96z"/>
		<path className="st0" d="M24.44,46.47"/>
	</g>
	<g>
		<path className="st0" d="M27.99,48.31c0.27-0.56,0.02-1.23-0.53-1.5c-0.56-0.26-1.24-0.03-1.5,0.54c-0.27,0.56-0.03,1.23,0.53,1.5
			C27.05,49.11,27.72,48.87,27.99,48.31z"/>
		<path className="st0" d="M26.97,47.82"/>
	</g>
	<g>
		<path className="st0" d="M30.32,49.11c0.26-0.56,0.03-1.23-0.53-1.5c-0.56-0.27-1.23-0.03-1.5,0.53c-0.26,0.56-0.03,1.23,0.54,1.5
			C29.38,49.91,30.05,49.67,30.32,49.11z"/>
		<path className="st0" d="M29.31,48.63"/>
	</g>
	<g>
		<path className="st0" d="M32.62,49.46c0.27-0.56,0.03-1.23-0.54-1.5c-0.56-0.27-1.23-0.03-1.49,0.53c-0.27,0.56-0.03,1.23,0.53,1.5
			C31.69,50.26,32.36,50.02,32.62,49.46z"/>
		<path className="st0" d="M31.61,48.97"/>
	</g>
	<g>
		<path className="st0" d="M10.98,27.63c0.15-0.6-0.21-1.21-0.82-1.36c-0.6-0.15-1.22,0.21-1.37,0.82c-0.15,0.6,0.21,1.21,0.82,1.37
			C10.21,28.6,10.83,28.24,10.98,27.63z"/>
		<path className="st0" d="M9.89,27.36"/>
	</g>
	<g>
		<path className="st0" d="M11.74,31.86c0.15-0.6-0.21-1.21-0.82-1.37c-0.6-0.15-1.21,0.21-1.36,0.81c-0.15,0.6,0.21,1.21,0.81,1.36
			C10.97,32.83,11.59,32.46,11.74,31.86z"/>
		<path className="st0" d="M10.65,31.58"/>
	</g>
	<g>
		<path className="st0" d="M12.94,35.82c0.15-0.6-0.22-1.22-0.82-1.36c-0.6-0.15-1.22,0.21-1.37,0.81c-0.15,0.6,0.22,1.22,0.82,1.37
			C12.18,36.79,12.79,36.42,12.94,35.82z"/>
		<path className="st0" d="M11.85,35.54"/>
	</g>
	<g>
		<path className="st0" d="M14.44,39.34c0.16-0.61-0.21-1.22-0.82-1.37c-0.6-0.15-1.22,0.22-1.36,0.82c-0.15,0.61,0.22,1.22,0.81,1.37
			C13.68,40.3,14.29,39.94,14.44,39.34z"/>
		<path className="st0" d="M13.36,39.06"/>
	</g>
	<g>
		<path className="st0" d="M16.54,42.35c0.15-0.6-0.22-1.21-0.82-1.37c-0.6-0.14-1.21,0.22-1.37,0.82c-0.14,0.6,0.22,1.21,0.82,1.36
			C15.78,43.32,16.39,42.95,16.54,42.35z"/>
		<path className="st0" d="M15.45,42.08"/>
	</g>
	<g>
		<path className="st0" d="M18.43,44.89c0.15-0.6-0.21-1.21-0.81-1.36c-0.61-0.15-1.21,0.21-1.37,0.81c-0.15,0.6,0.21,1.22,0.82,1.36
			C17.67,45.85,18.28,45.49,18.43,44.89z"/>
		<path className="st0" d="M17.34,44.61"/>
	</g>
	<g>
		<path className="st0" d="M20.73,47.48c0.15-0.6-0.21-1.21-0.81-1.36c-0.6-0.15-1.22,0.21-1.36,0.82c-0.16,0.6,0.21,1.21,0.81,1.36
			C19.96,48.45,20.57,48.08,20.73,47.48z"/>
		<path className="st0" d="M19.64,47.21"/>
	</g>
	<g>
		<path className="st0" d="M23.53,49.04c0.15-0.6-0.22-1.22-0.82-1.37c-0.61-0.15-1.21,0.22-1.37,0.82c-0.15,0.6,0.22,1.21,0.82,1.36
			C22.76,50,23.37,49.64,23.53,49.04z"/>
		<path className="st0" d="M22.43,48.76"/>
	</g>
	<g>
		<path className="st0" d="M26.29,50.15c0.15-0.6-0.21-1.22-0.82-1.37c-0.6-0.15-1.21,0.21-1.37,0.82c-0.15,0.6,0.22,1.21,0.82,1.36
			C25.52,51.12,26.14,50.76,26.29,50.15z"/>
		<path className="st0" d="M25.2,49.88"/>
	</g>
	<g>
		<path className="st0" d="M29.03,50.98c0.15-0.6-0.21-1.21-0.81-1.36c-0.6-0.15-1.21,0.22-1.37,0.82c-0.15,0.6,0.22,1.21,0.82,1.36
			C28.27,51.95,28.88,51.59,29.03,50.98z"/>
		<path className="st0" d="M27.94,50.71"/>
	</g>
	<g>
		<path className="st0" d="M31.47,51.32c0.15-0.6-0.21-1.21-0.82-1.36c-0.6-0.15-1.21,0.21-1.36,0.81c-0.16,0.61,0.21,1.22,0.81,1.37
			C30.71,52.29,31.32,51.92,31.47,51.32z"/>
		<path className="st0" d="M30.39,51.04"/>
	</g>
	<g>
		<path className="st0" d="M33.8,51.21c0.15-0.6-0.22-1.21-0.82-1.36c-0.6-0.15-1.21,0.21-1.36,0.82c-0.16,0.6,0.21,1.21,0.82,1.36
			C33.04,52.17,33.65,51.81,33.8,51.21z"/>
		<path className="st0" d="M32.71,50.93"/>
	</g>
	<g>
		<path className="st0" d="M8.32,34.03c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.07c-0.03,0.62,0.44,1.15,1.07,1.18
			C7.75,35.13,8.28,34.65,8.32,34.03z"/>
		<path className="st0" d="M7.19,33.97"/>
	</g>
	<g>
		<path className="st0" d="M9.88,38.03c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.07c-0.03,0.62,0.44,1.14,1.06,1.18
			C9.33,39.12,9.85,38.64,9.88,38.03z"/>
		<path className="st0" d="M8.76,37.97"/>
	</g>
	<g>
		<path className="st0" d="M11.84,41.67c0.04-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.07c-0.03,0.62,0.44,1.15,1.06,1.18
			C11.28,42.77,11.81,42.29,11.84,41.67z"/>
		<path className="st0" d="M10.71,41.61"/>
	</g>
	<g>
		<path className="st0" d="M13.99,44.83c0.03-0.62-0.44-1.15-1.07-1.18c-0.62-0.03-1.14,0.45-1.18,1.07c-0.03,0.62,0.45,1.15,1.07,1.18
			C13.44,45.93,13.97,45.45,13.99,44.83z"/>
		<path className="st0" d="M12.88,44.77"/>
	</g>
	<g>
		<path className="st0" d="M16.64,47.38c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.44-1.18,1.06c-0.03,0.62,0.45,1.16,1.07,1.18
			C16.08,48.47,16.61,48,16.64,47.38z"/>
		<path className="st0" d="M15.52,47.31"/>
	</g>
	<g>
		<path className="st0" d="M18.99,49.5c0.04-0.62-0.44-1.14-1.07-1.18c-0.62-0.03-1.14,0.45-1.18,1.06c-0.03,0.62,0.45,1.15,1.06,1.18
			C18.43,50.6,18.96,50.11,18.99,49.5z"/>
		<path className="st0" d="M17.87,49.44"/>
	</g>
	<g>
		<path className="st0" d="M21.75,51.59c0.03-0.62-0.44-1.15-1.06-1.18c-0.62-0.03-1.15,0.45-1.18,1.07c-0.03,0.62,0.44,1.15,1.07,1.18
			C21.19,52.69,21.72,52.22,21.75,51.59z"/>
		<path className="st0" d="M20.63,51.53"/>
	</g>
	<g>
		<path className="st0" d="M24.79,52.57c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.15,0.45-1.18,1.06c-0.03,0.63,0.44,1.15,1.07,1.18
			C24.23,53.67,24.76,53.19,24.79,52.57z"/>
		<path className="st0" d="M23.67,52.51"/>
	</g>
	<g>
		<path className="st0" d="M27.73,53.13c0.03-0.62-0.45-1.15-1.07-1.18c-0.62-0.03-1.14,0.45-1.18,1.07c-0.03,0.62,0.44,1.15,1.06,1.18
			C27.16,54.23,27.69,53.75,27.73,53.13z"/>
		<path className="st0" d="M26.6,53.07"/>
	</g>
	<g>
		<path className="st0" d="M30.57,53.41c0.03-0.62-0.44-1.15-1.06-1.18c-0.62-0.03-1.14,0.45-1.18,1.07c-0.04,0.62,0.45,1.15,1.07,1.18
			C30.01,54.51,30.55,54.03,30.57,53.41z"/>
		<path className="st0" d="M29.45,53.35"/>
	</g>
	<g>
		<path className="st0" d="M33.67,55.77c0.03-0.62-0.45-1.15-1.06-1.18c-0.62-0.03-1.15,0.45-1.18,1.07c-0.03,0.62,0.44,1.15,1.07,1.18
			C33.11,56.87,33.64,56.4,33.67,55.77z"/>
		<path className="st0" d="M32.54,55.72"/>
	</g>
	<g>
		<path className="st0" d="M36.26,52.1c0.03-0.62-0.44-1.15-1.07-1.18c-0.62-0.04-1.15,0.44-1.18,1.06c-0.03,0.63,0.45,1.15,1.07,1.19
			C35.7,53.19,36.23,52.71,36.26,52.1z"/>
		<path className="st0" d="M35.14,52.04"/>
	</g>
	<g>
		<path className="st0" d="M6.95,40.82c-0.09-0.61-0.67-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28c0.09,0.61,0.66,1.04,1.28,0.94
			C6.61,42.01,7.04,41.43,6.95,40.82z"/>
		<path className="st0" d="M5.84,40.98"/>
	</g>
	<g>
		<path className="st0" d="M9.27,44.43c-0.09-0.62-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.27c0.09,0.61,0.66,1.04,1.27,0.95
			C8.93,45.61,9.36,45.04,9.27,44.43z"/>
		<path className="st0" d="M8.15,44.59"/>
	</g>
	<g>
		<path className="st0" d="M11.89,47.63c-0.09-0.61-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.28c0.09,0.61,0.66,1.04,1.27,0.95
			C11.56,48.82,11.99,48.24,11.89,47.63z"/>
		<path className="st0" d="M10.78,47.79"/>
	</g>
	<g>
		<path className="st0" d="M14.63,50.31c-0.09-0.62-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.28c0.09,0.61,0.66,1.03,1.27,0.94
			C14.29,51.49,14.72,50.92,14.63,50.31z"/>
		<path className="st0" d="M13.52,50.47"/>
	</g>
	<g>
		<path className="st0" d="M17.72,52.28c-0.09-0.62-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.67-0.95,1.28c0.09,0.61,0.66,1.04,1.27,0.95
			C17.39,53.47,17.81,52.9,17.72,52.28z"/>
		<path className="st0" d="M16.61,52.45"/>
	</g>
	<g>
		<path className="st0" d="M20.44,53.91c-0.09-0.62-0.67-1.04-1.28-0.95c-0.61,0.09-1.04,0.66-0.95,1.28c0.09,0.61,0.66,1.04,1.28,0.95
			C20.1,55.09,20.53,54.52,20.44,53.91z"/>
		<path className="st0" d="M19.33,54.07"/>
	</g>
	<g>
		<path className="st0" d="M23.55,55.43c-0.09-0.62-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.27c0.08,0.62,0.66,1.04,1.27,0.95
			C23.22,56.61,23.64,56.04,23.55,55.43z"/>
		<path className="st0" d="M22.44,55.59"/>
	</g>
	<g>
		<path className="st0" d="M26.73,55.79c-0.09-0.61-0.66-1.04-1.28-0.95c-0.61,0.09-1.03,0.66-0.94,1.27c0.09,0.61,0.66,1.04,1.27,0.96
			C26.4,56.97,26.82,56.4,26.73,55.79z"/>
		<path className="st0" d="M25.62,55.95"/>
	</g>
	<g>
		<path className="st0" d="M29.93,56.93c-0.09-0.62-0.66-1.04-1.28-0.96c-0.62,0.1-1.04,0.67-0.95,1.28c0.09,0.61,0.66,1.04,1.27,0.95
			C29.6,58.11,30.02,57.54,29.93,56.93z"/>
		<path className="st0" d="M28.81,57.09"/>
	</g>
	<g>
		<path className="st0" d="M39.38,56.72c-0.09-0.61-0.66-1.04-1.27-0.95c-0.62,0.09-1.04,0.66-0.95,1.28c0.09,0.61,0.66,1.04,1.28,0.95
			C39.04,57.9,39.47,57.33,39.38,56.72z"/>
		<path className="st0" d="M38.27,56.88"/>
	</g>
	<g>
		<path className="st0" d="M6.93,47.74c-0.21-0.58-0.85-0.89-1.44-0.68c-0.58,0.21-0.89,0.86-0.68,1.44c0.2,0.58,0.85,0.89,1.44,0.68
			C6.84,48.97,7.14,48.33,6.93,47.74z"/>
		<path className="st0" d="M5.88,48.13"/>
	</g>
	<g>
		<path className="st0" d="M9.92,50.83c-0.21-0.58-0.85-0.89-1.44-0.68C7.9,50.36,7.59,51,7.8,51.59c0.2,0.58,0.85,0.89,1.43,0.68
			C9.82,52.06,10.12,51.42,9.92,50.83z"/>
		<path className="st0" d="M8.86,51.21"/>
	</g>
	<g>
		<path className="st0" d="M13.11,53.46c-0.21-0.59-0.85-0.89-1.44-0.68c-0.58,0.21-0.89,0.85-0.68,1.44c0.21,0.59,0.85,0.89,1.43,0.68
			C13.02,54.69,13.32,54.04,13.11,53.46z"/>
		<path className="st0" d="M12.06,53.84"/>
	</g>
	<g>
		<path className="st0" d="M16.32,55.56c-0.21-0.59-0.86-0.89-1.44-0.69c-0.58,0.21-0.89,0.85-0.68,1.44c0.21,0.58,0.85,0.89,1.44,0.68
			C16.22,56.77,16.53,56.14,16.32,55.56z"/>
		<path className="st0" d="M15.25,55.93"/>
	</g>
	<g>
		<path className="st0" d="M19.74,56.89c-0.21-0.58-0.85-0.89-1.43-0.68c-0.59,0.21-0.9,0.85-0.69,1.44c0.21,0.59,0.85,0.89,1.43,0.68
			C19.64,58.12,19.94,57.47,19.74,56.89z"/>
		<path className="st0" d="M18.68,57.27"/>
	</g>
	<g>
		<path className="st0" d="M22.72,57.95c-0.21-0.59-0.85-0.89-1.44-0.68c-0.58,0.21-0.89,0.85-0.68,1.44c0.21,0.59,0.85,0.89,1.43,0.68
			C22.62,59.17,22.93,58.54,22.72,57.95z"/>
		<path className="st0" d="M21.66,58.33"/>
	</g>
	<g>
		<path className="st0" d="M26.07,58.83c-0.21-0.59-0.85-0.89-1.43-0.68c-0.59,0.21-0.9,0.85-0.69,1.44c0.21,0.58,0.85,0.89,1.43,0.68
			C25.97,60.06,26.28,59.42,26.07,58.83z"/>
		<path className="st0" d="M25.01,59.21"/>
	</g>
	<g>
		<path className="st0" d="M33.16,59.86c-0.21-0.59-0.85-0.9-1.44-0.69c-0.58,0.21-0.89,0.85-0.68,1.44c0.21,0.59,0.85,0.89,1.43,0.68
			C33.06,61.08,33.37,60.44,33.16,59.86z"/>
		<path className="st0" d="M32.1,60.23"/>
	</g>
	<g>
		<path className="st0" d="M8.27,54.54c-0.32-0.53-1.01-0.7-1.55-0.39c-0.53,0.32-0.7,1.01-0.38,1.55c0.32,0.53,1.01,0.71,1.54,0.39
			C8.42,55.76,8.59,55.07,8.27,54.54z"/>
		<path className="st0" d="M7.31,55.12"/>
	</g>
	<g>
		<path className="st0" d="M11.8,56.99c-0.32-0.54-1.01-0.71-1.55-0.39c-0.53,0.31-0.71,1.01-0.39,1.54c0.32,0.53,1.01,0.7,1.54,0.39
			C11.94,58.22,12.12,57.52,11.8,56.99z"/>
		<path className="st0" d="M10.83,57.56"/>
	</g>
	<g>
		<path className="st0" d="M15.45,58.94c-0.32-0.53-1.01-0.71-1.54-0.4c-0.54,0.32-0.71,1.01-0.39,1.54c0.32,0.53,1.01,0.71,1.54,0.39
			C15.59,60.17,15.77,59.47,15.45,58.94z"/>
		<path className="st0" d="M14.48,59.51"/>
	</g>
	<g>
		<path className="st0" d="M19,60.36c-0.32-0.53-1.01-0.71-1.54-0.39c-0.54,0.32-0.71,1.01-0.39,1.54c0.32,0.53,1.01,0.71,1.55,0.39
			C19.14,61.59,19.32,60.9,19,60.36z"/>
		<path className="st0" d="M18.03,60.94"/>
	</g>
	<g>
		<path className="st0" d="M22.62,61.01c-0.32-0.53-1.02-0.7-1.55-0.39c-0.53,0.32-0.7,1.01-0.38,1.55c0.31,0.54,1.01,0.71,1.54,0.39
			C22.76,62.24,22.93,61.55,22.62,61.01z"/>
		<path className="st0" d="M21.65,61.59"/>
	</g>
	<g>
		<path className="st0" d="M25.75,61.47c-0.31-0.54-1.01-0.71-1.54-0.39c-0.54,0.32-0.71,1.01-0.4,1.54c0.32,0.53,1.01,0.71,1.54,0.38
			C25.89,62.7,26.06,62,25.75,61.47z"/>
		<path className="st0" d="M24.78,62.05"/>
	</g>
	<g>
		<path className="st0" d="M10.91,60.94c-0.42-0.45-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59c0.42,0.46,1.13,0.5,1.59,0.08
			C11.29,62.12,11.33,61.41,10.91,60.94z"/>
		<path className="st0" d="M10.08,61.7"/>
	</g>
	<g>
		<path className="st0" d="M14.85,62.65c-0.42-0.45-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59c0.42,0.46,1.13,0.5,1.59,0.08
			C15.23,63.83,15.26,63.12,14.85,62.65z"/>
		<path className="st0" d="M14.01,63.41"/>
	</g>
	<g>
		<path className="st0" d="M18.81,63.86c-0.42-0.46-1.13-0.5-1.59-0.08c-0.46,0.42-0.5,1.13-0.08,1.59c0.41,0.46,1.13,0.5,1.59,0.08
			C19.19,65.03,19.22,64.32,18.81,63.86z"/>
		<path className="st0" d="M17.97,64.61"/>
	</g>
	<g>
		<path className="st0" d="M29.58,66.18c-0.42-0.46-1.13-0.49-1.59-0.08c-0.46,0.41-0.5,1.12-0.08,1.59c0.42,0.46,1.13,0.5,1.59,0.08
			C29.96,67.35,30,66.64,29.58,66.18z"/>
		<path className="st0" d="M28.75,66.93"/>
	</g>
	<g>
		<path className="st0" d="M26.24,64.5c-0.42-0.46-1.13-0.5-1.59-0.09c-0.46,0.42-0.5,1.14-0.08,1.59c0.42,0.47,1.13,0.5,1.59,0.08
			C26.62,65.67,26.65,64.95,26.24,64.5z"/>
		<path className="st0" d="M25.41,65.25"/>
	</g>
	<g>
		<path className="st0" d="M14.75,66.71c-0.5-0.37-1.2-0.27-1.58,0.23c-0.37,0.5-0.27,1.2,0.23,1.58c0.5,0.37,1.21,0.26,1.57-0.24
			C15.35,67.79,15.24,67.09,14.75,66.71z"/>
		<path className="st0" d="M14.08,67.62"/>
	</g>
	<g>
		<path className="st0" d="M18.94,67.62c-0.5-0.37-1.2-0.27-1.57,0.23c-0.37,0.5-0.27,1.2,0.23,1.58c0.5,0.37,1.21,0.26,1.58-0.23
			C19.54,68.7,19.44,68,18.94,67.62z"/>
		<path className="st0" d="M18.27,68.53"/>
	</g>
	<g>
		<path className="st0" d="M23.06,68.03c-0.5-0.37-1.2-0.27-1.58,0.23c-0.37,0.5-0.26,1.2,0.23,1.57c0.5,0.37,1.21,0.27,1.58-0.23
			C23.66,69.1,23.56,68.4,23.06,68.03z"/>
		<path className="st0" d="M22.39,68.93"/>
	</g>
	<g>
		<path className="st0" d="M23.54,72.91c-0.56-0.26-1.23-0.03-1.5,0.53c-0.27,0.56-0.03,1.23,0.53,1.5c0.56,0.27,1.23,0.03,1.5-0.53
			C24.34,73.84,24.1,73.18,23.54,72.91z"/>
		<path className="st0" d="M23.06,73.92"/>
	</g>
	<g>
		<path className="st0" d="M47.94,35.6c0.09,0.61,0.66,1.04,1.27,0.95c0.62-0.09,1.05-0.66,0.96-1.27c-0.09-0.61-0.66-1.04-1.27-0.95
			C48.28,34.41,47.85,34.99,47.94,35.6z"/>
		<path className="st0" d="M49.06,35.44"/>
	</g>
	<g>
		<path className="st0" d="M53.05,35.38c0.21,0.58,0.86,0.89,1.44,0.68c0.58-0.21,0.89-0.85,0.68-1.43c-0.2-0.58-0.85-0.89-1.43-0.68
			C53.15,34.15,52.84,34.8,53.05,35.38z"/>
		<path className="st0" d="M54.11,35.01"/>
	</g>
	<g>
		<path className="st0" d="M47.07,32.65c0.2,0.59,0.85,0.89,1.44,0.69c0.58-0.21,0.89-0.85,0.68-1.44c-0.21-0.59-0.85-0.89-1.44-0.68
			C47.17,31.42,46.86,32.07,47.07,32.65z"/>
		<path className="st0" d="M48.13,32.27"/>
	</g>
	<g>
		<path className="st0" d="M45.2,34.04c0.21,0.59,0.85,0.89,1.44,0.69c0.58-0.22,0.89-0.86,0.68-1.44c-0.21-0.59-0.86-0.89-1.44-0.68
			C45.3,32.81,44.99,33.45,45.2,34.04z"/>
		<path className="st0" d="M46.26,33.66"/>
	</g>
	<g>
		<path className="st0" d="M52.92,28.66c0.31,0.53,1,0.7,1.54,0.39c0.53-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.7-1.54-0.39
			C52.78,27.44,52.6,28.13,52.92,28.66z"/>
		<path className="st0" d="M53.89,28.08"/>
	</g>
	<g>
		<path className="st0" d="M49.19,29.07c0.32,0.53,1.01,0.7,1.54,0.39c0.54-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39
			C49.04,27.84,48.87,28.53,49.19,29.07z"/>
		<path className="st0" d="M50.15,28.49"/>
	</g>
	<g>
		<path className="st0" d="M46.67,30.41c0.31,0.53,1,0.71,1.54,0.39c0.54-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39
			C46.52,29.19,46.35,29.88,46.67,30.41z"/>
		<path className="st0" d="M47.63,29.84"/>
	</g>
	<g>
		<path className="st0" d="M44.69,31.9c0.32,0.54,1.01,0.71,1.54,0.39c0.53-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39
			C44.55,30.68,44.37,31.37,44.69,31.9z"/>
		<path className="st0" d="M45.66,31.33"/>
	</g>
	<g>
		<path className="st0" d="M43.13,33.63c0.31,0.54,1.01,0.71,1.54,0.39c0.54-0.32,0.71-1.01,0.39-1.54c-0.32-0.53-1.01-0.71-1.54-0.39
			C42.98,32.41,42.81,33.1,43.13,33.63z"/>
		<path className="st0" d="M44.1,33.06"/>
	</g>
	<g>
		<path className="st0" d="M58.54,26.05c0.42,0.46,1.12,0.5,1.59,0.08c0.46-0.42,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.5-1.59-0.08
			C58.15,24.87,58.12,25.59,58.54,26.05z"/>
		<path className="st0" d="M59.37,25.29"/>
	</g>
	<g>
		<path className="st0" d="M51.38,24.84c0.42,0.46,1.13,0.5,1.59,0.08c0.46-0.42,0.5-1.12,0.08-1.59c-0.42-0.46-1.13-0.49-1.59-0.08
			C51,23.67,50.96,24.38,51.38,24.84z"/>
		<path className="st0" d="M52.22,24.08"/>
	</g>
	<g>
		<path className="st0" d="M48.54,26.3c0.41,0.46,1.13,0.5,1.59,0.08c0.46-0.42,0.5-1.13,0.08-1.59c-0.42-0.46-1.13-0.49-1.59-0.08
			C48.16,25.13,48.12,25.84,48.54,26.3z"/>
		<path className="st0" d="M49.37,25.55"/>
	</g>
	<g>
		<path className="st0" d="M46.07,27.97c0.41,0.46,1.13,0.5,1.59,0.08c0.47-0.42,0.5-1.13,0.08-1.59c-0.41-0.46-1.13-0.5-1.58-0.08
			C45.69,26.8,45.66,27.52,46.07,27.97z"/>
		<path className="st0" d="M46.91,27.22"/>
	</g>
	<g>
		<path className="st0" d="M43.86,29.79c0.42,0.46,1.13,0.5,1.59,0.08c0.46-0.41,0.5-1.13,0.08-1.59c-0.41-0.46-1.13-0.5-1.59-0.08
			C43.47,28.62,43.44,29.33,43.86,29.79z"/>
		<path className="st0" d="M44.69,29.04"/>
	</g>
	<g>
		<path className="st0" d="M42.22,31.64c0.42,0.46,1.13,0.5,1.59,0.08c0.46-0.41,0.5-1.12,0.08-1.59c-0.41-0.46-1.13-0.5-1.59-0.08
			C41.83,30.47,41.8,31.18,42.22,31.64z"/>
		<path className="st0" d="M43.05,30.89"/>
	</g>
	<g>
		<path className="st0" d="M41.02,33.64c0.42,0.46,1.13,0.5,1.59,0.08c0.46-0.41,0.5-1.13,0.08-1.58c-0.42-0.46-1.12-0.5-1.58-0.08
			C40.64,32.47,40.6,33.18,41.02,33.64z"/>
		<path className="st0" d="M41.86,32.88"/>
	</g>
</g>
<path className="st0" d="M73.28,6.81c1.25,0,2.31,0.44,3.18,1.31c0.87,0.87,1.31,1.91,1.31,3.13c0,1.24-0.44,2.28-1.31,3.15
	c-0.87,0.86-1.93,1.3-3.16,1.3c-1.26,0-2.31-0.44-3.18-1.3c-0.87-0.88-1.31-1.95-1.31-3.2c0-1.19,0.44-2.21,1.31-3.07
	C71,7.27,72.06,6.84,73.28,6.81z M77.23,19.86v22.42h-7.94V19.86H77.23z"/>
<path className="st0" d="M102.46,16.57H92.31v5.5h9.59v7.31h-9.59v5.59h10.15v7.31H83.67V9.25h18.79V16.57z"/>
<path className="st0" d="M120.64,16.57v25.71h-8.65V16.57h-7V9.25h22.72v7.32H120.64z"/>
<path className="st0" d="M153.23,11.14l-3.44,6.68c-1.83-1.47-3.71-2.2-5.62-2.2c-1.2,0-2.15,0.34-2.82,1.03
	c-0.56,0.54-0.85,1.15-0.85,1.8c0,1,0.68,1.83,2.05,2.49c0.4,0.17,1.69,0.6,3.91,1.25c2.88,0.86,4.94,2,6.22,3.44
	c1.26,1.42,1.9,3.33,1.9,5.72c0,4.25-1.43,7.37-4.26,9.35c-2.32,1.63-5.19,2.44-8.62,2.44c-4.07,0-7.91-1.25-11.49-3.74l3.68-6.93
	c2.57,2.24,5.1,3.35,7.58,3.35c1.52,0,2.63-0.38,3.32-1.17c0.54-0.63,0.82-1.31,0.82-2.04c0-0.9-0.35-1.61-1.07-2.13
	c-0.71-0.52-2.08-1.08-4.1-1.67c-3.14-0.93-5.23-1.82-6.26-2.67c-1.76-1.43-2.64-3.62-2.64-6.55c0-3.43,1.13-6.19,3.41-8.27
	c2.05-1.9,4.67-2.85,7.82-2.85C146.37,8.47,149.85,9.36,153.23,11.14z"/>
<path className="st0" d="M171.84,19.08c4.46,0,7.94,1.35,10.45,4.06c2.06,2.22,3.1,4.87,3.1,7.97c0,3.63-1.35,6.61-4.06,8.93
	c-2.42,2.08-5.61,3.11-9.59,3.11c-2.52,0-4.88-0.54-7.08-1.62c-2.04-1.02-3.65-2.55-4.81-4.63c-1.01-1.76-1.5-3.75-1.5-5.99
	c0-3.45,1.36-6.36,4.06-8.71C164.74,20.19,167.9,19.15,171.84,19.08z M171.85,26.01c-1.41,0-2.61,0.48-3.59,1.48
	c-1,0.99-1.5,2.18-1.5,3.53c0,1.44,0.5,2.66,1.5,3.65c0.98,1,2.19,1.48,3.62,1.48c1.4,0,2.6-0.48,3.6-1.48
	c1-0.99,1.51-2.19,1.51-3.59c0-1.41-0.49-2.61-1.48-3.58C174.52,26.52,173.31,26.02,171.85,26.01z"/>
<path className="st0" d="M197.78,5.96v36.32h-7.93V5.96H197.78z"/>
<path className="st0" d="M211.13,19.86v12.71c0,2.75,1.35,4.12,4.06,4.12c2.69,0,4.04-1.37,4.04-4.12V19.86h7.94v14.23
	c0,2.69-0.85,4.78-2.5,6.29c-2.1,1.9-5.27,2.84-9.48,2.84c-4.24,0-7.41-0.95-9.5-2.84c-1.67-1.51-2.51-3.6-2.51-6.29V19.86H211.13z"
	/>
<path className="st0" d="M241.37,26.47v15.81h-7.94V26.47h-2.6v-6.6h2.6v-6.75h7.94v6.75h4.56v6.6H241.37z"/>
<path className="st0" d="M252.81,6.81c1.25,0,2.31,0.44,3.19,1.31c0.87,0.87,1.3,1.91,1.3,3.13c0,1.24-0.43,2.28-1.3,3.15
	c-0.88,0.86-1.94,1.3-3.16,1.3c-1.27,0-2.32-0.44-3.18-1.3c-0.88-0.88-1.32-1.95-1.32-3.2c0-1.19,0.44-2.21,1.31-3.07
	C250.52,7.27,251.57,6.84,252.81,6.81z M256.75,19.86v22.42h-7.94V19.86H256.75z"/>
<path className="st0" d="M274.78,19.08c4.46,0,7.95,1.35,10.44,4.06c2.07,2.22,3.11,4.87,3.11,7.97c0,3.63-1.36,6.61-4.06,8.93
	c-2.42,2.08-5.61,3.11-9.58,3.11c-2.52,0-4.89-0.54-7.07-1.62c-2.06-1.02-3.65-2.55-4.83-4.63c-0.99-1.76-1.5-3.75-1.5-5.99
	c0-3.45,1.36-6.36,4.06-8.71C267.69,20.19,270.83,19.15,274.78,19.08z M274.8,26.01c-1.43,0-2.62,0.48-3.6,1.48
	c-1,0.99-1.5,2.18-1.5,3.53c0,1.44,0.5,2.66,1.5,3.65c0.98,1,2.18,1.48,3.62,1.48c1.41,0,2.6-0.48,3.6-1.48
	c1-0.99,1.51-2.19,1.51-3.59c0-1.41-0.49-2.61-1.48-3.58C277.47,26.52,276.24,26.02,274.8,26.01z"/>
<path className="st0" d="M292.79,19.86h7.93v2.83c0.92-1.08,1.76-1.84,2.54-2.29c1.25-0.72,2.8-1.08,4.63-1.08
	c2.74,0,4.91,0.83,6.48,2.49c0.77,0.79,1.31,1.64,1.62,2.55c0.3,0.91,0.45,2.14,0.45,3.65v14.28h-7.94V30.93
	c0-1.75-0.16-2.93-0.48-3.55c-0.26-0.54-0.68-0.97-1.26-1.29c-0.59-0.32-1.22-0.47-1.89-0.47c-1.38,0-2.48,0.51-3.3,1.52
	c-0.56,0.71-0.85,1.75-0.85,3.14v12h-7.93V19.86z"/>
<path className="st0" d="M339.5,20.52l-2.67,5.12c-1.49-0.7-2.91-1.05-4.29-1.05c-0.71,0-1.29,0.14-1.74,0.45
	c-0.46,0.29-0.67,0.68-0.67,1.14c0,0.6,0.42,1.05,1.26,1.35c0.24,0.1,1.01,0.28,2.3,0.56c1.84,0.37,3.25,0.94,4.22,1.71
	c1.53,1.19,2.3,2.83,2.3,4.93c0,2.75-1.1,4.9-3.29,6.44c-1.89,1.32-4.35,1.98-7.39,1.98c-3.06,0-6.05-0.87-8.98-2.61l2.87-5.6
	c2.29,1.49,4.4,2.23,6.34,2.23c0.73,0,1.34-0.17,1.81-0.49c0.47-0.33,0.7-0.73,0.7-1.22c0-0.57-0.21-0.98-0.64-1.25
	c-0.43-0.27-1.35-0.54-2.75-0.84c-1.91-0.4-3.34-0.91-4.27-1.54c-1.55-1.03-2.33-2.59-2.33-4.67c0-2.33,0.83-4.25,2.5-5.76
	c1.72-1.56,4.2-2.34,7.48-2.34C334.75,19.08,337.17,19.57,339.5,20.52z"/>
<g>
	<path className="st0" d="M348.59,12.65c0.75,0.71,1.12,1.57,1.12,2.59c0,1.02-0.37,1.88-1.12,2.59c-0.74,0.7-1.66,1.05-2.75,1.05
		c-1.08,0-2-0.35-2.74-1.05c-0.76-0.71-1.12-1.57-1.12-2.59c0-1.02,0.36-1.89,1.12-2.59c0.75-0.71,1.67-1.05,2.74-1.05
		C346.92,11.6,347.84,11.95,348.59,12.65z M348.04,13.09c-0.59-0.58-1.33-0.87-2.2-0.87c-0.87,0-1.6,0.29-2.19,0.87
		c-0.59,0.58-0.9,1.3-0.9,2.15c0,0.85,0.31,1.56,0.9,2.15c0.59,0.58,1.32,0.87,2.19,0.87c0.87,0,1.6-0.3,2.2-0.87
		c0.6-0.59,0.9-1.3,0.9-2.15C348.94,14.39,348.64,13.68,348.04,13.09z M344.17,13.14h0.34h1.41c0.48,0,0.85,0.1,1.12,0.3
		c0.27,0.2,0.4,0.48,0.4,0.84c0,0.39-0.14,0.7-0.41,0.91c-0.2,0.18-0.46,0.27-0.78,0.32l1.26,1.84h-0.39h-0.4l-1.13-1.82l-0.73,0.01
		v1.82h-0.35h-0.34V13.14z M344.86,14.97h0.94c0.32,0,0.56-0.06,0.7-0.17c0.15-0.11,0.23-0.28,0.23-0.52c0-0.21-0.07-0.37-0.23-0.46
		c-0.15-0.1-0.39-0.14-0.7-0.14h-0.94V14.97z"/>
</g>
<g>
	<g>
		<g>
			<path className="st0" d="M75.55,54.22h1.07h1.08l5,13.91h-1.01h-1.01l-1.42-4.04H73.7l-1.46,4.04h-0.96H70.3L75.55,54.22z
				 M74.3,62.44h4.38l-2.15-6.17l0,0L74.3,62.44z"/>
			<path className="st0" d="M89.9,54.22h0.94h4.78c1.77,0,3.17,0.63,4.22,1.89c1.04,1.26,1.57,2.95,1.57,5.08c0,2.12-0.54,3.8-1.6,5.06
				c-1.07,1.26-2.51,1.89-4.33,1.89h-4.62H89.9V54.22z M91.79,66.52h3.44c1.35,0,2.39-0.46,3.12-1.39c0.74-0.93,1.1-2.24,1.1-3.94
				c0-1.71-0.35-3.03-1.05-3.96c-0.71-0.93-1.71-1.39-3.01-1.39h-3.61V66.52z"/>
			<path className="st0" d="M103.61,54.22h1.74v1.93h-1.74V54.22z M103.64,58h0.85h0.86v10.13h-0.86h-0.85V58z"/>
			<path className="st0" d="M106.78,58h0.99h0.99l2.71,8.29h0l2.81-8.29h0.93h0.94l-3.77,10.13h-0.91h-0.91L106.78,58z"/>
			<path className="st0" d="M117.61,54.22h1.74v1.93h-1.74V54.22z M117.63,58h0.85h0.85v10.13h-0.85h-0.85V58z"/>
			<path className="st0" d="M127.67,60.94c-0.05-0.56-0.28-1-0.69-1.31c-0.41-0.31-0.95-0.46-1.64-0.46c-0.71,0-1.24,0.13-1.62,0.37
				c-0.36,0.25-0.55,0.61-0.55,1.08c0,0.36,0.13,0.63,0.39,0.81c0.26,0.18,0.78,0.37,1.55,0.56l1.75,0.41
				c0.99,0.24,1.69,0.57,2.11,1c0.42,0.41,0.63,0.99,0.63,1.75c0,1-0.37,1.8-1.09,2.38c-0.72,0.58-1.7,0.88-2.92,0.88
				c-1.43,0-2.49-0.28-3.19-0.85c-0.7-0.56-1.08-1.45-1.16-2.66h1.63c0.08,0.72,0.33,1.24,0.76,1.56c0.43,0.32,1.07,0.49,1.95,0.49
				c0.76,0,1.34-0.15,1.73-0.44c0.39-0.29,0.6-0.71,0.6-1.27c0-0.36-0.13-0.62-0.39-0.8c-0.26-0.19-0.78-0.37-1.56-0.55l-1.76-0.42
				c-0.96-0.23-1.63-0.54-2.04-0.95c-0.4-0.41-0.6-0.97-0.6-1.7c0-0.95,0.33-1.71,1.02-2.26c0.68-0.56,1.59-0.85,2.75-0.85
				c1.18,0,2.12,0.29,2.82,0.86c0.7,0.57,1.07,1.36,1.11,2.38H127.67z"/>
			<path className="st0" d="M131.6,54.22h1.74v1.93h-1.74V54.22z M131.62,58h0.85h0.85v10.13h-0.85h-0.85V58z"/>
			<path className="st0" d="M136.59,66.93c-0.86-0.99-1.3-2.28-1.3-3.88s0.44-2.89,1.3-3.87c0.87-0.98,2.01-1.48,3.41-1.48
				c1.41,0,2.55,0.5,3.41,1.48c0.87,0.98,1.3,2.27,1.3,3.87s-0.43,2.89-1.3,3.88c-0.86,0.98-2,1.47-3.41,1.47
				C138.59,68.4,137.46,67.91,136.59,66.93z M142.13,65.88c0.53-0.7,0.8-1.64,0.8-2.83c0-1.18-0.27-2.13-0.8-2.83
				c-0.53-0.71-1.24-1.06-2.14-1.06c-0.9,0-1.61,0.35-2.13,1.06c-0.53,0.7-0.79,1.64-0.79,2.83c0,1.19,0.26,2.13,0.79,2.83
				c0.53,0.7,1.24,1.06,2.13,1.06C140.89,66.94,141.6,66.59,142.13,65.88z"/>
			<path className="st0" d="M146.64,58h0.8h0.82v1.5l0.37-0.5c0.74-0.87,1.66-1.3,2.77-1.3c1.11,0,1.98,0.3,2.58,0.91
				c0.61,0.6,0.91,1.47,0.91,2.58v6.94h-0.85h-0.86v-6.36c0-0.89-0.17-1.54-0.51-1.93c-0.34-0.39-0.9-0.59-1.67-0.59
				c-0.82,0-1.47,0.31-1.95,0.93c-0.48,0.63-0.72,1.47-0.72,2.53v5.42h-0.85h-0.85V58z"/>
			<path className="st0" d="M163.52,66.93c-0.87-0.99-1.31-2.28-1.31-3.88s0.44-2.89,1.31-3.87c0.87-0.98,2-1.48,3.4-1.48
				c1.41,0,2.55,0.5,3.41,1.48c0.87,0.98,1.3,2.27,1.3,3.87s-0.43,2.89-1.3,3.88c-0.86,0.98-2,1.47-3.41,1.47
				C165.52,68.4,164.39,67.91,163.52,66.93z M169.06,65.88c0.53-0.7,0.79-1.64,0.79-2.83c0-1.18-0.27-2.13-0.79-2.83
				c-0.53-0.71-1.25-1.06-2.14-1.06c-0.9,0-1.61,0.35-2.14,1.06c-0.53,0.7-0.79,1.64-0.79,2.83c0,1.19,0.26,2.13,0.79,2.83
				c0.53,0.7,1.24,1.06,2.14,1.06C167.81,66.94,168.53,66.59,169.06,65.88z"/>
			<path className="st0" d="M175.69,59.42v8.71h-0.85h-0.85v-8.71h-1.39V58h1.39v-1.72c0-0.75,0.22-1.32,0.66-1.7
				c0.45-0.38,1.11-0.57,1.99-0.57l0.75,0.03v1.54l-0.67-0.03c-0.33,0-0.58,0.11-0.76,0.32c-0.17,0.21-0.26,0.51-0.26,0.9V58h1.7
				v1.42H175.69z"/>
			<path className="st0" d="M195.55,63.03c0,1.71-0.48,3.05-1.45,4.02c-0.97,0.97-2.3,1.45-4.02,1.45c-1.78,0-3.14-0.47-4.07-1.4
				c-0.93-0.93-1.4-2.29-1.4-4.08v-8.81h0.94h0.94v8.67c0,1.29,0.31,2.27,0.91,2.95c0.61,0.67,1.51,1.01,2.67,1.01
				c1.17,0,2.07-0.34,2.68-1.01c0.61-0.68,0.91-1.66,0.91-2.95v-8.67h0.94h0.94V63.03z"/>
			<path className="st0" d="M200.36,68.13h-0.91h-0.91V54.22h1.13h1.13l6.96,11.3v-11.3h0.9h0.91v13.91h-1.03h-1.03l-7.16-11.35V68.13z"
				/>
			<path className="st0" d="M212.82,54.22h0.94h0.94v13.91h-0.94h-0.94V54.22z"/>
			<path className="st0" d="M229.64,63.01c-0.25,1.72-0.9,3.06-1.97,4.03c-1.08,0.98-2.44,1.46-4.09,1.46c-1.92,0-3.44-0.66-4.59-1.99
				c-1.13-1.32-1.71-3.1-1.71-5.34c0-2.24,0.6-4.03,1.78-5.35c1.18-1.33,2.77-1.99,4.75-1.99c1.57,0,2.86,0.4,3.87,1.21
				c1.01,0.81,1.61,1.92,1.82,3.34h-1.82c-0.18-0.92-0.6-1.64-1.28-2.13c-0.69-0.51-1.55-0.76-2.62-0.76c-1.4,0-2.5,0.51-3.33,1.53
				c-0.83,1.03-1.24,2.41-1.24,4.14c0,1.85,0.38,3.24,1.15,4.21c0.76,0.97,1.88,1.45,3.34,1.45c1.08,0,1.97-0.33,2.69-1
				c0.71-0.66,1.18-1.61,1.42-2.83H229.64z"/>
			<path className="st0" d="M233.06,66.49c-1.25-1.35-1.87-3.12-1.87-5.3c0-2.2,0.62-3.97,1.87-5.32c1.25-1.35,2.88-2.02,4.9-2.02
				c2.04,0,3.67,0.68,4.92,2.02c1.24,1.35,1.87,3.12,1.87,5.32c0,2.18-0.63,3.95-1.87,5.3c-1.25,1.35-2.88,2.02-4.92,2.02
				C235.94,68.51,234.31,67.84,233.06,66.49z M241.47,65.28c0.89-1.04,1.33-2.41,1.33-4.1c0-1.7-0.44-3.07-1.33-4.11
				c-0.89-1.04-2.06-1.56-3.51-1.56c-1.44,0-2.61,0.52-3.5,1.56c-0.89,1.04-1.33,2.42-1.33,4.11c0,1.69,0.44,3.05,1.33,4.1
				c0.89,1.04,2.06,1.56,3.5,1.56C239.41,66.84,240.58,66.32,241.47,65.28z"/>
			<path className="st0" d="M248.74,68.13h-0.9h-0.92V54.22h1.35h1.35l3.97,11.84l0,0l3.95-11.84h1.35h1.35v13.91h-0.91h-0.91V56.36
				h-0.01l-3.92,11.77h-0.92h-0.9l-3.93-11.74h0V68.13z"/>
			<path className="st0" d="M274.41,68.51c-1.93,0-3.49-0.67-4.68-2.02c-1.2-1.35-1.79-3.12-1.79-5.3c0-2.2,0.6-3.97,1.82-5.32
				c1.22-1.35,2.81-2.02,4.77-2.02c1.52,0,2.84,0.43,3.92,1.28c1.1,0.85,1.74,1.94,1.93,3.27h-1.82c-0.18-0.92-0.62-1.64-1.34-2.13
				c-0.72-0.51-1.66-0.76-2.8-0.76c-1.35,0-2.45,0.53-3.28,1.58c-0.84,1.05-1.27,2.43-1.27,4.13c0,1.81,0.41,3.21,1.22,4.2
				c0.81,0.99,1.96,1.48,3.43,1.48c1.44,0,2.59-0.52,3.48-1.57c0.14-0.17,0.26-0.34,0.37-0.52c0.16-0.25,0.28-0.59,0.39-1.03
				c0.11-0.44,0.16-0.86,0.16-1.26v-0.17h-4.36v-1.59h6.08v7.36h-1.17l-0.45-1.75l-0.11,0.12
				C277.77,67.84,276.28,68.51,274.41,68.51z"/>
			<path className="st0" d="M283.38,54.22h0.85h0.85v13.91h-0.85h-0.85V54.22z"/>
			<path className="st0" d="M288.37,66.93c-0.87-0.99-1.3-2.28-1.3-3.88s0.43-2.89,1.3-3.87c0.86-0.98,1.99-1.48,3.39-1.48
				c1.42,0,2.56,0.5,3.42,1.48c0.86,0.98,1.3,2.27,1.3,3.87s-0.44,2.89-1.3,3.88c-0.86,0.98-1.99,1.47-3.42,1.47
				C290.37,68.4,289.23,67.91,288.37,66.93z M293.91,65.88c0.53-0.7,0.79-1.64,0.79-2.83c0-1.18-0.26-2.13-0.79-2.83
				c-0.53-0.71-1.24-1.06-2.15-1.06c-0.88,0-1.61,0.35-2.12,1.06c-0.53,0.7-0.8,1.64-0.8,2.83c0,1.19,0.27,2.13,0.8,2.83
				c0.52,0.7,1.24,1.06,2.12,1.06C292.67,66.94,293.38,66.59,293.91,65.88z"/>
			<path className="st0" d="M298.29,54.22h0.85h0.85v5.1c0.75-1.1,1.71-1.63,2.89-1.62c1.33,0,2.38,0.46,3.15,1.37
				c0.78,0.91,1.16,2.14,1.16,3.69c0,1.76-0.39,3.14-1.17,4.14c-0.78,1-1.86,1.5-3.24,1.5c-1.15,0-2.06-0.43-2.73-1.31l-0.16-0.21
				v1.25h-1.6V54.22z M302.69,66.93c0.89,0,1.56-0.34,2.02-1.01c0.46-0.67,0.69-1.65,0.69-2.94c0-1.27-0.22-2.21-0.66-2.81
				c-0.44-0.62-1.12-0.92-2.04-0.92c-0.94,0-1.62,0.35-2.06,1.03c-0.42,0.69-0.65,1.78-0.65,3.26c0,1.08,0.24,1.92,0.7,2.5
				C301.15,66.63,301.82,66.93,302.69,66.93z"/>
			<path className="st0" d="M311.86,68.4c-0.99,0-1.77-0.27-2.36-0.79c-0.58-0.53-0.87-1.25-0.87-2.14c0-0.91,0.28-1.64,0.82-2.17
				c0.54-0.53,1.34-0.87,2.39-1l2.32-0.29c0.19-0.01,0.36-0.04,0.54-0.09c0.22-0.05,0.39-0.17,0.51-0.34
				c0.12-0.17,0.18-0.39,0.18-0.64v-0.09c0-0.54-0.2-0.96-0.61-1.28c-0.41-0.3-0.98-0.46-1.71-0.46c-0.7,0-1.24,0.16-1.64,0.49
				c-0.4,0.33-0.63,0.81-0.71,1.45h-1.57c0.08-1.11,0.47-1.94,1.17-2.49c0.7-0.56,1.7-0.85,3-0.85c1.23,0,2.17,0.27,2.81,0.8
				c0.65,0.54,0.96,1.31,0.96,2.33v5.57c0,0.16,0.05,0.31,0.16,0.41c0.11,0.1,0.25,0.16,0.42,0.16c0.05,0,0.12-0.01,0.22-0.02
				c0.1-0.01,0.2-0.03,0.32-0.06v1.23c-0.16,0.06-0.34,0.11-0.52,0.15c-0.18,0.03-0.33,0.06-0.46,0.06c-0.64,0-1.1-0.17-1.4-0.53
				c-0.19-0.23-0.32-0.56-0.41-0.99c-0.13,0.16-0.27,0.31-0.43,0.45C314.14,68.02,313.09,68.4,311.86,68.4z M315.39,64.12v-1.09
				c-0.31,0.14-0.66,0.25-1.05,0.31l-1.56,0.22c-0.82,0.11-1.42,0.31-1.8,0.58c-0.38,0.26-0.57,0.63-0.57,1.09
				c0,0.57,0.16,1,0.47,1.3c0.31,0.31,0.75,0.46,1.32,0.46c0.89,0,1.65-0.25,2.27-0.72c0.42-0.34,0.7-0.73,0.83-1.16
				c0.03-0.07,0.04-0.21,0.06-0.39C315.38,64.54,315.39,64.34,315.39,64.12z"/>
			<path className="st0" d="M320.01,54.22h0.85h0.85v13.91h-0.85h-0.85V54.22z"/>
		</g>
	</g>
	<g>
		<path className="st0" d="M263.58,53.85c0.34,0,0.67,0.09,0.99,0.26c0.32,0.17,0.57,0.42,0.75,0.75c0.18,0.32,0.28,0.66,0.28,1.01
			c0,0.35-0.09,0.68-0.27,1c-0.18,0.32-0.43,0.57-0.74,0.75c-0.32,0.18-0.66,0.27-1.01,0.27c-0.35,0-0.68-0.09-1-0.27
			c-0.32-0.18-0.57-0.42-0.75-0.75c-0.17-0.32-0.26-0.66-0.26-1c0-0.35,0.09-0.69,0.27-1.01c0.18-0.32,0.43-0.57,0.76-0.75
			C262.91,53.94,263.23,53.85,263.58,53.85z M263.58,54.18c-0.28,0-0.56,0.07-0.83,0.22c-0.27,0.14-0.48,0.35-0.63,0.62
			c-0.15,0.27-0.23,0.55-0.23,0.84c0,0.29,0.08,0.57,0.23,0.84c0.15,0.27,0.35,0.47,0.62,0.62c0.27,0.15,0.55,0.22,0.84,0.22
			c0.29,0,0.57-0.07,0.84-0.22c0.27-0.14,0.48-0.35,0.62-0.62c0.15-0.27,0.22-0.55,0.22-0.84c0-0.29-0.07-0.57-0.22-0.84
			c-0.15-0.27-0.36-0.47-0.63-0.62C264.13,54.25,263.86,54.18,263.58,54.18z M262.69,56.97V54.8h0.75c0.25,0,0.44,0.02,0.55,0.06
			c0.11,0.04,0.21,0.11,0.28,0.21c0.06,0.09,0.1,0.2,0.1,0.32c0,0.16-0.05,0.3-0.16,0.41c-0.11,0.12-0.27,0.18-0.46,0.2
			c0.08,0.03,0.14,0.07,0.19,0.12c0.09,0.09,0.2,0.23,0.32,0.42l0.26,0.43h-0.43l-0.19-0.34c-0.16-0.27-0.28-0.44-0.37-0.51
			c-0.06-0.05-0.16-0.08-0.28-0.08h-0.21v0.92H262.69z M263.04,55.76h0.43c0.2,0,0.34-0.03,0.41-0.09c0.07-0.06,0.11-0.14,0.11-0.24
			c0-0.06-0.02-0.12-0.05-0.17c-0.04-0.05-0.09-0.09-0.15-0.12c-0.06-0.02-0.18-0.04-0.35-0.04h-0.4V55.76z"/>
	</g>
</g>
</svg>
    )}
}

export default NavLogo